import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  fetchClasses,
  CREATE_NOTIFICATION_SUCCESS_MESSAGE,
  notificationsPath,
  createNotification,
  fetchNotification,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import NotificationForm from "../../../templates/manager/NotificationForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export const CopyNotification = (props: {
  match: { params: { id: string } };
}) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const id = parseInt(props.match.params.id, 10);
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === CREATE_NOTIFICATION_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(notificationsPath);
    }
  }, [history, dispatch, state.success_message]);

  const createNotificationFunc = React.useCallback(
    (notification: {
      id: number;
      content: string;
      for_teacher: boolean;
      class_ids: number[];
    }) => {
      dispatch(peep(createNotification(notification)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    dispatch(fetchNotification(id));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, id, currentYear]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.notifications, to: notificationsPath }]}
        currentTitle={titles.copyNotification}
      />
      {state.notification?.id === id && (
        <NotificationForm
          title={titles.copyNotification}
          calling={calling}
          error={state.error}
          notification={{ ...state.notification, id: 0 }}
          classes={state.classes}
          upsertNotification={createNotificationFunc}
        />
      )}
    </div>
  );
};

export default CopyNotification;
